import { t } from '@lingui/core/macro';
import { AccessTypes, VisibilityEnum } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';
import { Option } from 'modules/template-editor/domain/interface/form/template';

/** Опции собираются при вызове: подпись переводится на языке момента рендера, а не старта модуля. */
export const getAccessOptions = (): Option<AccessTypes>[] => [
  { label: t`Приватный`, value: 'private' },
  { label: t`Публичный`, value: 'public' },
  { label: t`Дефолтный`, value: 'default' },
];

export const getVisibilityOptions = (): Option<VisibilityEnum>[] => [
  { label: t`Все`, value: 'all' },
  { label: t`Супер админы`, value: 'superAdmin' },
];
